import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Tabs from "../reuseable/Tabs";
import dict from "../../Data/dict.json";
import PaymentTable from "./PaymentTable";
import RedeemButton from "./RedeemButton";
// import BuyNow from "./BuyNow";
import PaymentInstruction from "../../Pages/dashboard/PaymentInstruction";
import { ArrowBack } from "@material-ui/icons";
import WaitForTransactionProcess from "./WaitForTransactionProcess";
import ErrorPayment from "./ErrorPayment";
import PaymentMethod from "./PaymentMethod";
import domain_list from "../../Data/domain_list";

const menu_tabs = ["license", "redeem code"];

export default function Pricing({ from, is_redirect = false, create_payment }) {
  const [package_selected, set_package_selected] = useState("personal");
  const [actived_tab, set_actived_tab] = useState("license");
  const [page, set_page_state] = useState("packages"); // packages, payment, loading
  const [package_object, set_package_object] = useState({});
  const [payment_id, set_payment_id] = useState("");
  const [error, set_error] = useState({});
  const [month] = useState(); // Preserved to match original destructuring

  const auth = useSelector((state) => state.auth);

  const { domain } = auth;

  const premium_status = domain_list?.[domain]?.status;

  useEffect(() => {
    const payment = localStorage.getItem("payment");

    const process_payment = async () => {
      if (payment && payment !== "") {
        const body = {
          payment_type: "license_1",
          month: parseInt(payment, 10), // ✅ Diberi key yang benar
          payment_methode: "midtrans",
        };

        let response = "";
        const current_url = window.location.href;
        if (current_url.includes("user_profile")) {
          response = await create_payment(body, "user_profile");
        } else {
          response = await create_payment(body);
        }

        if (response?.status === 200 && response?.id) {
          set_payment_id(response.id);
          set_page({ new_page: "payment" });
        } else {
          set_page({ new_page: "error" });
          set_error(response);
        }
      }
    };

    process_payment();
  }, [create_payment]);

  // on_set_month = (month) => {
  //   this.setState({ month });
  // };

  // on_set_collaborators = (collaborators) => {
  //   this.setState({ collaborators });
  // };

  const set_page = ({ package_object: new_package_object, new_page }) => {
    const list_of_pages = [
      "packages",
      "payment_method",
      "payment",
      "loading",
      "error",
    ];

    set_page_state((prev_page) =>
      list_of_pages.includes(new_page) ? new_page : prev_page,
    );

    if (new_package_object) {
      set_package_object(new_package_object);
    }
  };

  const handle_tab = (value) => {
    set_actived_tab(value);
  };

  // local storage
  const language = localStorage?.language || "ina";

  // props

  // state
  // on_set_collaborators

  let content, title, description;
  if (actived_tab === "license") {
    if (page === "packages") {
      title = dict?.["Best license price for you"]?.[language];
      description =
        dict?.[
          "Get features at the best price on the market! Limited timeoffer to boost your productivity."
        ]?.[language];
      content = (
        <PaymentTable
          set_package_selected={set_package_selected}
          package_selected={package_selected}
          month={month}
          // on_set_month={this.on_set_month}
          // on_set_collaborators={this.on_set_collaborators}
          page={page}
          set_page={set_page}
        />
      );
    } else if (page === "payment_method") {
      title = "metode pembayaran"; //dict?.["Payment"]?.[language];
      // description = dict?.["Get features at the best price on the market! Limited timeoffer to boost your productivity."]?.[language]

      content = (
        <PaymentMethod
          set_page={set_page}
          month={month}
          set_payment_id={set_payment_id}
          package_object={package_object}
          set_error={set_error}
        />
      );
    } else if (page === "payment") {
      title = dict?.["Payment"]?.[language];
      // description = dict?.["Get features at the best price on the market! Limited time offer to boost your productivity."]?.[language]

      content = (
        <PaymentInstruction
          is_redirect={is_redirect}
          payment_id={payment_id || ""}
        />
      );
    } else if (page === "loading") {
      title = dict?.["Please Wait..."]?.[language];
      content = <WaitForTransactionProcess />;
    } else if (page === "error") {
      title = dict?.["Error"]?.[language];
      content = <ErrorPayment error={error} />;
    }
  } else if (actived_tab === "redeem code") {
    title = "Redeem MAPID Code";
    description = dict?.["Enter your code to get discount."]?.[language];
    content = <RedeemButton />;
  }

  return (
    <>
      {premium_status === "premium" ? (
        <main className="text_big text_center">
          Anda tidak diperbolehkan mengakses platform ini.
          <br />
          Harap hubungi admin untuk mengaktifasi akun Anda.
        </main>
      ) : (
        <main className="flex flex_col gap_30">
          <header className="flex justify_start gap_20">
            {page !== "packages" && (
              <div className="flex justify_start">
                <div
                  onClick={() => {
                    if (
                      page === "payment_method" ||
                      page === "payment" ||
                      page === "error"
                    ) {
                      set_page({ new_page: "packages" });
                    }

                    // if (page === "bundle") {
                    //   this.set_page({ new_page: "packages" });
                    // } else if (page !== "packages" && actived_tab === "license") {
                    //   this.set_page({ new_page: "bundle" });
                    // } else if (page !== "packages" && actived_tab === "access") {
                    //   this.set_page({ new_page: "packages" });
                    // }
                  }}
                  className="pointer hover_bigger w_50 h_50 bg_darkBlue center_perfect text_white rounded_50"
                >
                  <ArrowBack />
                </div>
              </div>
            )}
            <div>
              <label className="font_30 bold">{title}</label>
              <p>{description}</p>
            </div>
          </header>
          {["dashboard"].includes(from) && (
            <section className="center_perfect gap_20 h_full">
              {page === "packages" && (
                <Tabs
                  actived_tab={actived_tab}
                  menu_tabs={menu_tabs}
                  handle_tab={handle_tab}
                />
              )}
            </section>
          )}

          <footer style={{ minHeight: "300px" }}>{content}</footer>
        </main>
      )}
    </>
  );
}
